export default __webpack_public_path__ + "static/media/closeIcon.609353b8.svg";